import { Component, input, output } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { PasswordService } from "src/app/services/password.service";

@Component({
  selector: "app-reset-password",
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: "./reset-password.component.html",
  styles: ``,
})
export class ResetPasswordComponent {
  key = input<string>();

  resetPassword = output<{
    key: string;
    newPassword: string;
  }>();

  busy = input<boolean>();

  passwordComplexity = this.passwordService.defaultPasswordComplexity();

  newPassword = new FormControl<string>("", [
    this.passwordService.passwordComplexityValidator(this.passwordComplexity),
  ]);

  newPasswordCheck = new FormControl<string>("", [Validators.required]);

  form = new FormGroup(
    {
      newPassword: this.newPassword,
      newPasswordCheck: this.newPasswordCheck,
    },
    [this.passwordService.passwordsMustMatchValidator()],
  );

  constructor(private readonly passwordService: PasswordService) {}

  submit() {
    if (this.form.valid) {
      this.resetPassword.emit({
        key: this.key() || "",
        newPassword: this.newPassword.value || "",
      });
    }
  }
}
